import { Button } from '@mui/material';
import React, { useCallback, useEffect, useState } from "react";
//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Col, Row } from 'antd';
import ParentClassCard from 'components/ParentClassCard';
import FlatList from 'flatlist-react';
import { filter, get } from "lodash";
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { handleGetClass } from 'store/classes/thunks';
import SpinLoader from 'components/Loader/SpinLoader';
import SentryWrap from 'components/Sentry';



function ClassHome({ userClasses}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const renderItem = useCallback((item, index) => {
        return (<ParentClassCard key={item.id} classInfo={item} />)
    },[userClasses])


    const redirectToHome = async () => {
        try{
            setLoading(true)
            await dispatch(handleGetClass(userClasses[0].id))
            navigate(`/parent/class`);
        }catch(error){
            console.log(error)
        }finally{
            setLoading(false)
        }  
    }
    useEffect(() => {
        if (userClasses && (userClasses.length == 0 || userClasses.length ==1)) {
            const isArchived = get(userClasses[0],"archived",false); 
            if(!isArchived){
                redirectToHome()
            }  
        }
    }, [userClasses])
    return (
        <SentryWrap>
          <SpinLoader dataloader={loading} />
            <Row className="teacherHm">
                <Col xs={24} sm={24} md={24} lg={20}>
                    <Row gutter={[40, 40]}>
                        <div className="techrHmBtn">
                            <Button className='text-white'>My classes</Button>
                        </div>
                    </Row>
                    <Row className="teacherHmInr" gutter={[40, 40]} stdyle={{paddingLeft:16, marginBottom:80}}>
                        <FlatList
                            list={filter(userClasses,k=>!k.archived)}
                            renderItem={renderItem}
                            renderWhenEmpty={() => <div>No classes available</div>}
                            sortBy={["id"]}
                        />
                    </Row>
                </Col>
                <Col xs={24} sm={24} md={24} lg={4}></Col>
            </Row>
        </SentryWrap>
    );
}

const mapStateToProps = state => ({
    userClasses: state.userClasses,
    booksAllList: state.booksAllList,
});

export default connect(mapStateToProps, null)(ClassHome);
